import { useFormContext } from 'react-hook-form';

import type { WorkRedistributeFormData } from '@/component/Task';
import { useRangeDistibuteMutation } from '@/hook';
import type { Task, User } from '@/type';

export const useWorkRedistributeSubmit = (
  task: Task,
  unAssignedUserIDList: User['id'][],
  onSuccess: () => void,
) => {
  const { mutate: distribute } = useRangeDistibuteMutation();
  const form = useFormContext<WorkRedistributeFormData>();
  const { handleSubmit } = form;

  const onSubmit = handleSubmit(data => {
    distribute(
      {
        pTaskID: task.id,
        distributions: data.taskAllocations.filter(
          t => !unAssignedUserIDList.includes(t.userID.toString()),
        ),
      },
      { onSuccess },
    );
  });

  return { onSubmit };
};
